export const currency = "AED";

export const formatPrice = (
  price: string | number = 0,
  locale = "en-US",
  currencyType = currency
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyType,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(Number(price || 0));
};

export const AddZero = (num: number) => {
  if (num < 10 && num > -10) {
    return num < 10 && num >= 0 ? `0${num}` : `-0${Math.abs(num)}`;
  }

  return num;
};

export const countRow = (page: number, limit: number, index: number) => {
  return index + 1 + (page - 1) * limit;
};

// sum all data
export const sumOfArray = (arr: any[], field: string) => {
  return arr?.reduce((acc, curr) => acc + curr?.[field] || 0, 0);
};

export const percentage = (value: number, total: number) => {
  return (value / total) * 100;
};

export const fixedNumber = (val: number, fixed: number = 1) => {
  return val ? parseFloat(val?.toFixed(fixed)) : 0;
};

export const addCommaInNumber = (number: number | string) => {
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function formatSouthAsianNumber(number: number = 0) {
  const numStr = number.toString();
  const lastThree = numStr.slice(-3);
  const otherNumbers = numStr.slice(0, -3);

  if (otherNumbers === "") return lastThree;

  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
}

export const countParPageSerialNumber = (
  page: number,
  limit: number,
  index: number
) => {
  return addZeroIfInRange(index + 1 + (page - 1) * limit);
};

export const addZeroIfInRange = (num: number) => {
  if (num < 10 && num > -10) {
    return num < 10 && num >= 0 ? `0${num}` : `-0${Math.abs(num)}`;
  }

  return num;
};
